(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["oasisLayout"] = factory(require("vue"));
	else
		root["oasisLayout"] = factory(root["fiksuVueRuntime"]["Vue"]);
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__2554__) => {
return 